import { render, staticRenderFns } from "./List-Deliveries.vue?vue&type=template&id=00a09752"
import script from "./List-Deliveries.vue?vue&type=script&lang=js"
export * from "./List-Deliveries.vue?vue&type=script&lang=js"
import style0 from "./List-Deliveries.vue?vue&type=style&index=0&id=00a09752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports